import React from "react";
import { Edit2, Trash2 } from "lucide-react";

export const ActionButtons = ({ onEdit, onDelete, additionalButtons }) => {
  return (
    <div className="flex space-x-2">
      {additionalButtons}
      <button
        onClick={onEdit}
        className="p-1 text-blue-600 hover:bg-blue-50 rounded transition-colors"
        title="Edit"
      >
        <Edit2 className="w-4 h-4" />
      </button>
      <button
        onClick={onDelete}
        className="p-1 text-red-600 hover:bg-red-50 rounded transition-colors"
        title="Delete"
      >
        <Trash2 className="w-4 h-4" />
      </button>
    </div>
  );
};

export const PrimaryButton = ({ onClick, icon: Icon, children, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="flex items-center px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors disabled:opacity-50"
    >
      {Icon && <Icon className="w-5 h-5 mr-2" />}
      {children}
    </button>
  );
};

export const SecondaryButton = ({
  onClick,
  icon: Icon,
  children,
  type = "button",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className="flex items-center px-4 py-2 border border-slate-300 text-slate-700 rounded-lg hover:bg-slate-50 transition-colors"
    >
      {Icon && <Icon className="w-5 h-5 mr-2" />}
      {children}
    </button>
  );
};

export default ActionButtons;
